import React from 'react';

const StaticSearching: React.FC<React.SVGProps<SVGSVGElement>> = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 34 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect
        x="0.5"
        y="0.60498"
        width="36.4229"
        height="34.79"
        fill="url(#pattern0_3652_7105)"
      />
      <defs>
        <pattern
          id="pattern0_3652_7105"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use
            xlinkHref="#image0_3652_7105"
            transform="matrix(0.015778 0 0 0.0165185 -0.704565 -0.777321)"
          />
        </pattern>
        <image
          id="image0_3652_7105"
          width="150"
          height="150"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAAAAXNSR0IArs4c6QAAAyBJREFUeF7t1LFKw1AAhtF0UPDVnHwLV3eXLuLqap/Cqa8mKBhJIaBtXIQPAjldL/cn/XLIbvBTICiwCzZNKjCABUFSAKwkq1GwGEgKgJVkNQoWA0kBsJKsRsFiICkAVpLVKFgMJAXASrIaBYuBpABYSVajYDGQFAAryWoULAaSAmAlWY2CxUBSAKwkq1GwGEgKgJVkNQoWA0kBsJKsRsFiICkAVpLVKFgMJAXASrIaBYuBpABYSVajYDGQFAAryWoULAaSAmAlWY2CxUBSAKwkq1GwGEgKgJVkNQoWA0kBsJKsRsFiICkAVpLVKFgMJAXASrIaBYuBpABYSVajYDGQFAAryWoULAaSAmAlWY2CxUBSAKwkq1GwGEgKgJVkNQoWA0kBsJKsRsFiICkAVpLVKFgMJAXASrIaBYuBpABYSVajYDGQFAAryWoULAaSAmAlWY2CxUBSAKwkq1GwGEgKgJVkNQoWA0kBsJKsRsFiICmwKVgPd/vx/eNzeD0+Xfzv+9vHcRy+TpEPx+eL8+pu8lZXMLoZWDOMm+urU/aXt/2v/z6fT2fn8Mq7KzCQPMJmYE1fpLnghGsJ1nz+F7rp3tIXb4L337vJW13B6GZgTa1nAOdwfp4tfc3KuyswkDzCpmAlBY0uFgALjKQAWElWo2AxkBQAK8lqFCwGkgJgJVmNgsVAUgCsJKtRsBhICoCVZDUKFgNJAbCSrEbBYiApAFaS1ShYDCQFwEqyGgWLgaQAWElWo2AxkBQAK8lqFCwGkgJgJVmNgsVAUgCsJKtRsBhICoCVZDUKFgNJAbCSrEbBYiApAFaS1ShYDCQFwEqyGgWLgaQAWElWo2AxkBQAK8lqFCwGkgJgJVmNgsVAUgCsJKtRsBhICoCVZDUKFgNJAbCSrEbBYiApAFaS1ShYDCQFwEqyGgWLgaQAWElWo2AxkBQAK8lqFCwGkgJgJVmNgsVAUgCsJKtRsBhICoCVZDUKFgNJAbCSrEbBYiApAFaS1ShYDCQFwEqyGgWLgaQAWElWo2AxkBQAK8lqFCwGkgJgJVmNgsVAUgCsJKvRb3dFeJcZNbTdAAAAAElFTkSuQmCC"
        />
      </defs>
    </svg>
  );
};

export default StaticSearching;
